module.exports = __webpack_public_path__ + "static/media/tip-lamp.6551fd9a.svg";